import clsx from "clsx";
import React from "react";
import { DayPicker } from "react-day-picker";
import Button from "../../common/Button/Button";
import Icon from "../../common/Icon/Icon";
import styles from "./DateTimeInput.module.scss";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

const Calendar = ({ className, classNames, showOutsideDays = true, components, ...props }: CalendarProps) => {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={clsx(styles.calendar, className)}
      classNames={{
        months: styles.months,
        month: styles.month,
        month_caption: styles.monthCaption,
        caption: styles.caption,
        caption_label: styles.captionLabel,
        nav: styles.nav,
        nav_button: styles.navButton,
        nav_button_previous: styles.navButtonPrevious,
        nav_button_next: styles.navButtonNext,
        month_grid: styles.monthGrid,
        table: styles.table,
        weekdays: styles.weekdays,
        weekday: styles.weekday,
        head_row: styles.headRow,
        head_cell: styles.headCell,
        week: styles.week,
        row: styles.row,
        cell: styles.cell,
        button: styles.button,
        day: styles.day,
        day_button: styles.dayButton,
        selected: styles.selected,
        today: styles.today,
        outside: styles.outside,
        disabled: styles.disabled,
        hidden: styles.hidden,
        day_selected: styles.daySelected,
        day_today: styles.dayToday,
        day_outside: styles.dayOutside,
        day_disabled: styles.dayDisabled,
        day_hidden: styles.dayHidden,
        ...classNames,
      }}
      components={{
        PreviousMonthButton: ({ children: _children, className, ...buttonProps }) => (
          <Button
            {...buttonProps}
            icon
            type="button"
            label="Previous month"
            className={clsx(styles.navIconButton, className)}
          >
            <Icon name="go-back" />
          </Button>
        ),
        NextMonthButton: ({ children: _children, className, ...buttonProps }) => (
          <Button
            {...buttonProps}
            icon
            type="button"
            label="Next month"
            className={clsx(styles.navIconButton, className)}
          >
            <Icon name="go-forward" />
          </Button>
        ),
        ...components,
      }}
      {...props}
    />
  );
};

export default Calendar;
